export const tpfrontup =
  "Wyjazdy na narty i&nbsp;snowboard w&nbsp;sezonie <span>Zima&nbsp;2024/25</span>.";
export const tpfrontdown = "Odwiedź Travelplanet.pl";
export const tplink = "https://www.travelplanet.pl/narty/";
